const KEY = "archijo-consent";
const MAX_AGE = 182 * 24 * 3600 * 1000; // 6 months (REQ-766)
export const OPEN_EVENT = "archijo:cookies";
export const CHANGE_EVENT = "archijo:consent";

export function readConsent() {
  try {
    const c = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!c || Date.now() - c.at > MAX_AGE) return null;
    return c;
  } catch {
    return null;
  }
}

export function writeConsent(c) {
  const v = { audience: !!c.audience, ads: !!c.ads, thirdparty: !!c.thirdparty, at: Date.now() };
  try {
    localStorage.setItem(KEY, JSON.stringify(v));
  } catch {}
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: v }));
  return v;
}

// Before any choice: audience on (CNIL exemption), advertising and third-party off.
export const consentHeader = () => {
  const c = readConsent() || { audience: true, ads: false, thirdparty: false };
  return `a${c.audience ? 1 : 0}.d${c.ads ? 1 : 0}.t${c.thirdparty ? 1 : 0}`;
};

export const openCookies = () => window.dispatchEvent(new Event(OPEN_EVENT));
